// import Homepage from './components/Homepage'
import Login from './components/Login'
import Dashboard from './components/Dashboard'
import SocialLogin from './components/SocialLogin'
import Agreements from './components/Agreements'
import Invite from './components/Invite'
import Actions from './components/Actions'
import Survey from './components/Survey'
import Instantwin from './components/Instantwin'
import Question from './components/Question'
import VerifyMobile from './components/VerifyMobile'
import Profile from './components/Profile'
import EditAddress from './components/EditAddress'
import Catalog from './components/Catalog'
import Reward from './components/Reward'
import InsertCode from './components/InsertCode'
import Leaderboard from './components/Leaderboard'
import Settings from './components/Settings'
import Banned from './components/Banned'
import InfoPage from './components/InfoPage'
import NotFoundPage from './components/NotFoundPage'
import CompleteProfile from './components/CompleteProfile'
import Home from './components/LandingPage/Home'
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'index',
            component: Home,
            meta: {
                requiresGuest: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/socialLogin/:provider',
            name: 'socialLogin',
            component: SocialLogin
        },
        {
            path: '/agreements',
            name: 'agreements',
            component: Agreements,
            meta: {
                requiresAuth: true,
                blockNotifications: true
            }
        },
        {
            path: '/invite',
            name: 'invite',
            component: Invite,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/actions',
            name: 'actions',
            component: Actions,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/survey/:surveyId',
            name: 'survey',
            component: Survey,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/instantwin/:instantwinId',
            name: 'instantwin',
            component: Instantwin,
            meta: {
                requiresAuth: true,
                blockNotifications: true
            }

        },
        {
            path: '/question/:questionId',
            name: 'question',
            component: Question,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/verify/mobile',
            name: 'verifyMobile',
            component: VerifyMobile,
            meta: {
                requiresAuth: true,
                blockNotifications: true
            }
        },
        {
            path: '/settings/profile',
            name: 'profileSettings',
            component: Profile,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/settings/contact/edit',
            name: 'editAddress',
            component: EditAddress,
            meta: {
                requiresAuth: true,
                blockNotifications: true
            },
            props: true
        },
        {
            path: '/catalog',
            name: 'catalog',
            component: Catalog,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/catalog/rewards/',
            name: 'reward',
            component: Reward,
            meta: {
                requiresAuth: true
            },
            props: true
        },
        {
            path: '/code',
            name: 'insert-code',
            component: InsertCode,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/leaderboard',
            name: 'leaderboard',
            component: Leaderboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/banned',
            name: 'banned',
            component: Banned,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/info/:page',
            name: 'info',
            component: InfoPage
        },
        {
            path: '*',
            name: '404',
            component: NotFoundPage
        }, 
        {
            path: '/complete-profile',
            name: 'complete-profile',
            component: CompleteProfile,
            meta: {
                requiresAuth: true
            }
        },
    ],
    mode: 'history'
})

router.beforeEach(async (to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (store.state.user === undefined && !store.state.unavailableUserState) {
            await store.dispatch('getUserInfo');
        }

        if(!store.state.unavailableUserState && store.state.user.banned && to.path !== '/banned') {
            router.replace('/banned');
            return;
        }

        if (!store.state.unavailableUserState && to.path !== '/agreements' && (!store.state.user.tos || !store.state.user.privacy)) {
            router.replace('/agreements');
            return

        }

        if (!to.matched.some(record => record.meta.blockNotifications)) {
            store.dispatch('getUnreadMessages')
        }

        if (store.getters.isLoggedIn) {
            next()
            return
        }
        next('/')
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        if (store.getters.isLoggedIn) {
            next('/dashboard')
            return
        }
        next()
    } else {
        next()
    }
})

export default router